<template>
    <!--弹窗-->
    <el-dialog
        width="700px"
        class="plural"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
    >
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item label="单词:" class="query-form-item">
                <el-input
                    v-model="keyword"
                    placeholder="请输入单词"
                    style="width:160px"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="addPluralFunc">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="list" size="mini" border height="450">
            <el-table-column label="单词" width="200" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.keyword }}</span>
                </template>
            </el-table-column>
            <el-table-column label="单复数形式" min-width="130" align="center">
                <template slot-scope="scope">
                    <el-input
                        v-model="scope.row.plural_keywords"
                        placeholder="单复数形式,多个值用','拼接"
                        size="mini"
                        style="width:260px"
                        clearable
                    ></el-input>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="submitForm(scope.row)">更新</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="query.total" background :current-page="query.page"
                       style="margin-top: 10px;display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                @click="handleClose">关 闭
            </el-button>
        </el-row>
        <addPlural @close="getList" ref="addPluralDom"></addPlural>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/Product/Product.js'
    import addPlural from './components/addPlural'

    export default {
        data() {
            return {
                loading: false,
                list: [],
                keyword: '',
                query: {
                    page: 1,
                    limit: 10,
                    total: 0,
                },
            }
        },
        components: {addPlural},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            }
        },
        methods: {
            addPluralFunc(){
                this.$refs.addPluralDom.openModal()
            },
            getList() {
                this.loading = true
                api.seed_word_asin_list_get_singular_plural_list({keyword: this.keyword, ...this.query})
                    .then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.list = res.data.list
                            this.query.total = res.data.total
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        this.loading = false
                    })
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            submitForm(data) {
                if (this.list.length == 0) {
                    return this.$message({
                        type: 'error',
                        message: '请输入单词进行搜索单词具体数据!'
                    })
                }

                let str = JSON.parse(JSON.stringify(data.plural_keywords || ''))
                str = str.replace(/\s*(,|，)\s*/g, ',').trim()

                api.seed_word_asin_list_update_singular_plural({id: data.id, plural_keywords: str})
                    .then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '修改成功'})
                            this.getList()
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '网络出现问题，请查看数据是否添加完成！'
                        })
                    })
            },
            // 关闭弹窗
            handleClose() {
                this.disabled = false
                this.list = []
                this.keyword = ''
                this.$emit('close-callback', true)
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .plural {
        /deep/ .el-table__empty-block {
            border-bottom: 1px #ebeef5 solid;
        }

        /deep/ .el-dialog__body {
            padding-top: 0 !important;
        }
    }
</style>
